export default "__VITE_ASSET__Sh6dY_N9__"